import React, { useState } from 'react';
import CSR2022Banner from '../../../../Data/Events/2022/CSR2022Banner';
import CSR2023Banner from '../../../../Data/Events/2023/CSR2023Banner';
import "../CSS/EventsAndCSRInnerPages.css";

const CSRInnerPages = () => {
    const [toggleClassName, setToggleClassName] = useState(1);
    const handleToggleClassName = (e) => {
        setToggleClassName(e);
    }
  return (
    <>
    <section className="events-inner-pages-button-and-image-section-start-here">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-md-3 col-sm-3 col-3 events-inner-pages-button-div">
            {/* <div className="events-button-first-inner-div"></div> */}
            <h4 className={toggleClassName === 1 ? `click-events-inner-pages` : `without-click-events-inner-pages`} onClick={() => handleToggleClassName(1)}>2023</h4>
            <h4 className={toggleClassName === 2 ? `click-events-inner-pages` : `without-click-events-inner-pages`} onClick={() => handleToggleClassName(2)}>2022</h4>
          </div>
          <div className="col-md-9 col-sm-9 col-9 events-inner-pages-image-div">
            <div className="container-fluid">
                <div className="row justify-flex-start">
                    {
                        toggleClassName === 1 ?
                        <>
                        {
                        CSR2023Banner.map((items) => {
                            return(
                                <div className="col-md-6 col-sm-6 col-12 events-inner-pages-banner-images-div" key={items.id}>
                                    <div className="csr-events-inner-pages-banner-images-first-inner-div">
                                        {items.bannerImage}
                                        {items.bannerPara}
                                    </div>
                                </div>
                            );
                        })
                    }
                        </> : ""
                    }
                    {
                        toggleClassName === 2 ?
                        <>
                        {
                        CSR2022Banner.map((items) => {
                            return(
                                <div className="col-md-6 col-sm-6 col-12 events-inner-pages-banner-images-div" key={items.id}>
                                    <div className="csr-events-inner-pages-banner-images-first-inner-div">
                                        {items.bannerImage}
                                        {items.bannerPara}
                                    </div>
                                </div>
                            );
                        })
                    }
                        </> : ""
                    }
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  )
}

export default CSRInnerPages;